var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.msg.msg))]),_c('p',{staticClass:"btnBox"},[_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.test}},[_vm._v("立即处理")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }